import type { Variants } from 'framer-motion'

const FADE: Variants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.2,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.1,
    },
  },
}

const SCALE: Variants = {
  hidden: {
    y: '0',
    opacity: 0,
    scale: 0.85,
  },
  visible: {
    y: '0',
    opacity: 1,
    scale: 1,
    transition: {
      scale: { type: 'tween', ease: [0.34, 1.7, 0.55, 1], duration: 0.45 },
      default: { duration: 0.2 },
    },
  },
  exit: {
    y: '0',
    opacity: 0,
    scale: 0.9,
  },
}

export { FADE, SCALE }
